package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Loan(
  public val id: String,
  public val direction: String,
  public val counterparty: String,
  public val principal: Long,
  public val interest: Long,
  public val currency: String,
  public val date: String,
  public val due_date: String?,
  public val note: String?,
  public val account_id: String?,
  public val tx_id: String?,
  public val status: String,
  public val order_index: Long,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
